import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainImage", "counter", "thumbnail"]
  static values = { index: { type: Number, default: 0 } }

  connect() {
    this.updateDisplay()
  }

  next() {
    if (this.indexValue < this.thumbnailTargets.length - 1) {
      this.indexValue++
      this.updateDisplay()
    }
  }

  prev() {
    if (this.indexValue > 0) {
      this.indexValue--
      this.updateDisplay()
    }
  }

  select(event) {
    this.indexValue = parseInt(event.currentTarget.dataset.index)
    this.updateDisplay()
  }

  updateDisplay() {
    const thumb = this.thumbnailTargets[this.indexValue]
    if (!thumb) return

    this.mainImageTarget.src = thumb.dataset.fullSrc
    this.counterTarget.textContent = `${this.indexValue + 1} / ${this.thumbnailTargets.length}`

    this.thumbnailTargets.forEach((t, i) => {
      t.classList.toggle("ring-2", i === this.indexValue)
      t.classList.toggle("ring-primary", i === this.indexValue)
      t.classList.toggle("opacity-60", i !== this.indexValue)
    })
  }
}
